var isBezierDefinition = function isBezierDefinition(easing) {
  return Array.isArray(easing) && typeof easing[0] === "number";
};
export { isBezierDefinition };